import { BaseState } from '@/store/base-state';
import { TableOptions, PaginationProps } from '@/types';
import { default_software_license, default_not_active_software_licenses_filters } from '../services';
import {
  SoftwareLicenses,
  SoftwareLicensesFilters,
  SoftwareLicensesStatuses,
  SoftwareLicenseHistory,
  SoftwareLicenseCategories,
  SoftwareCartHistory,
} from '../types';

export default class SoftwareLicensesState extends BaseState {
  software_licenses: SoftwareLicenses.SoftwareLicense[] = [];
  software_licenses_loading = false;
  filters: SoftwareLicensesFilters = {
    search: '',
    statuses: [],
    cities: [],
    dates: [],
  };

  not_active_software_licenses: SoftwareLicenses.NotActiveSoftwareLicense[] = [];
  not_active_software_licenses_loading = false;
  not_active_software_licenses_filters: SoftwareLicenses.NotActiveSoftwareLicensesRequestFilters = default_not_active_software_licenses_filters();
  not_active_software_licenses_statuses: SoftwareLicenses.NotActiveSoftwareLicenseStatusItem[] = [];

  software_licenses_history: SoftwareLicenseHistory[] = [];
  software_licenses_history_filters: SoftwareLicensesFilters = {
    search: '',
    statuses: [],
    dates: [],
  };

  software_cart_history: SoftwareCartHistory[] = [];

  current_software_license: SoftwareLicenses.SoftwareLicense = default_software_license();

  cities: string[] = [];
  statuses: SoftwareLicensesStatuses[] = [];
  categories: SoftwareLicenseCategories[] = [];
  statuses_history: SoftwareLicensesStatuses[] = [];
  is_software_order_allowed = false
  is_modal_software_order_allowed = false;

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [],
    sortDesc: [false],
  };

  not_active_software_licenses_table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['nomenclature'],
    sortDesc: [true],
  };

  not_active_software_licenses_pagination_props: PaginationProps = this.create_pagination_props;

  table_options_software_licenses_history: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [false],
  };

  pagination_software_licenses_history: PaginationProps = {
    current_page: 1,
    total_pages: 1,
    total_items: 0,
    limit: 10,
  }
}
